import { FSharpMap__TryFind, ofList } from "./fable_modules/fable-library.3.7.18/Map.js";
import { memo, createElement } from "react";
import * as react from "react";
import { LocalizationSample } from "../public/pages/usage/localization/Localization.fs.js";
import { UseMediaQuerySample } from "../public/pages/usage/hooks/UseMediaQuery.fs.js";
import { Autocomplete } from "../public/pages/components/autocomplete/Autocomplete.fs.js";
import { SignIn } from "../public/pages/samples/sign-in/SignIn.fs.js";
import { DateTimePickersSample } from "../public/pages/samples/date-time-pickers/DateTimePickers.fs.js";
import { singleton, ofArray } from "./fable_modules/fable-library.3.7.18/List.js";
import { Union } from "./fable_modules/fable-library.3.7.18/Types.js";
import { union_type, tuple_type, list_type, lambda_type, class_type, string_type } from "./fable_modules/fable-library.3.7.18/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.18/Choice.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { split, substring, printf, toText, join } from "./fable_modules/fable-library.3.7.18/String.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_perform } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/./cmd.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library.3.7.18/AsyncBuilder.js";
import { Http_get } from "./fable_modules/Fable.SimpleHttp.3.5.0/Http.fs.js";
import { defaultArgWith } from "./fable_modules/fable-library.3.7.18/Option.js";
import { MuiHelpers_createElement } from "../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Skeleton, Collapse, Grid, IconButton, Tooltip, Paper, Typography } from "@mui/material";
import { useReact_useMemo_CF4EA67, React_useStateWithUpdater_1505, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.1.68.0/React.fs.js";
import { StyleImports_useTheme } from "../../src/Feliz.MaterialUI/./Styles.fs.js";
import { createObj, int32ToString } from "./fable_modules/fable-library.3.7.18/Util.js";
import { op_UnaryNegation_Int32 } from "./fable_modules/fable-library.3.7.18/Int32.js";
import Undo from "@mui/icons-material/Undo";
import { Interop_reactApi } from "./fable_modules/Feliz.1.68.0/./Interop.fs.js";
import Code from "@mui/icons-material/Code";
import GitHub from "@mui/icons-material/GitHub";
import { Code as Code_1 } from "./CommonViews.fs.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.Markdown.1.3.1/../Feliz.1.68.0/Interop.fs.js";
import react_markdown from "react-markdown";
import { useFeliz_React__React_useElmish_Static_78C5B8C8 } from "./fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export const samples = ofList(ofArray([["Samples.Usage.Localization.Localization", (sampleKey) => createElement(LocalizationSample, {
    sampleKey: sampleKey,
})], ["Samples.Usage.Hooks.UseMediaQuery", (sampleKey_1) => createElement(UseMediaQuerySample, {
    sampleKey: sampleKey_1,
})], ["Samples.Components.Autocomplete.Autocomplete", (key) => createElement(Autocomplete, {
    key: key,
    $key: key,
})], ["Samples.Samples.SignIn.SignIn", (key_1) => createElement(SignIn, {
    key: key_1,
    $key: key_1,
})], ["Samples.Samples.DateTimePickers.DateTimePickers", (key_2) => createElement(DateTimePickersSample, {
    key: key_2,
    $key: key_2,
})]]));

export class State extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Initial", "Loading", "Loaded"];
    }
}

export function State$reflection() {
    return union_type("SampleViewer.State", [], State, () => [[], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(lambda_type(string_type, class_type("Fable.React.ReactElement")), string_type, list_type(string_type)), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(lambda_type(string_type, class_type("Fable.React.ReactElement")), string_type, list_type(string_type))]], [["ErrorValue", string_type]]])]]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StartLoad", "LoadCompleted"];
    }
}

export function Msg$reflection() {
    return union_type("SampleViewer.Msg", [], Msg, () => [[["path", list_type(string_type)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(lambda_type(string_type, class_type("Fable.React.ReactElement")), string_type, list_type(string_type)), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(lambda_type(string_type, class_type("Fable.React.ReactElement")), string_type, list_type(string_type))]], [["ErrorValue", string_type]]])]]]);
}

export function init(path) {
    return [new State(0), singleton((dispatch) => {
        dispatch(new Msg(0, path));
    })];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        return [new State(2, msg.fields[0]), Cmd_none()];
    }
    else {
        const path = msg.fields[0];
        const url = join("/", path);
        return [new State(1), Cmd_OfAsyncWith_perform((x_1) => {
            Cmd_OfAsync_start(x_1);
        }, () => singleton_1.Delay(() => singleton_1.Bind(Http_get(url), (_arg) => {
            const statusCode = _arg[0] | 0;
            const responseText = _arg[1];
            if (statusCode === 200) {
                const codeBlock = toText(printf("```fsharp\n%s\n```"))(responseText);
                const sampleName = substring(split(responseText, ["\n"], null, 0)[0].trim(), 7);
                const sample = defaultArgWith(FSharpMap__TryFind(samples, sampleName), () => ((_arg_1) => MuiHelpers_createElement(Typography, [["sx", (delegateArg) => ((x) => ({
                    color: x.palette.error.main,
                }))(delegateArg)], ["paragraph", true], ["children", toText(printf("Sample not found: \u0027%s\u0027"))(sampleName)]])));
                return singleton_1.Return(new FSharpResult$2(0, [sample, codeBlock, path]));
            }
            else {
                return singleton_1.Return(new FSharpResult$2(1, toText(printf("Failed with status %i when loading %s"))(statusCode)(url)));
            }
        })), void 0, (arg_4) => (new Msg(1, arg_4)))];
    }
}

export const Demo = memo((demoInputProps) => {
    let elems, props_1, elements, props_6, props_10, elements_1, properties;
    const path = demoInputProps.path;
    const markdownCodeBlock = demoInputProps.markdownCodeBlock;
    const getSample = demoInputProps.getSample;
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const isExpanded = patternInput[0];
    const patternInput_1 = React_useStateWithUpdater_1505(0);
    const sampleKey = patternInput_1[0] | 0;
    const theme = StyleImports_useTheme();
    const bgColor = useReact_useMemo_CF4EA67(() => ((theme.palette.mode === "light") ? theme.palette.grey["100"] : theme.palette.grey.A700), [theme.palette.mode, theme.palette.grey]);
    const sample = useReact_useMemo_CF4EA67(() => getSample(int32ToString(sampleKey)), [int32ToString(sampleKey)]);
    const children_3 = ofArray([MuiHelpers_createElement(Paper, [["sx", {
        padding: theme.spacing(3),
        backgroundColor: bgColor,
    }], (elems = [MuiHelpers_createElement(Tooltip, [["title", "Reset sample"], ["children", MuiHelpers_createElement(IconButton, [["sx", {
        float: "right",
        marginTop: op_UnaryNegation_Int32(theme.spacing(2)),
        marginRight: op_UnaryNegation_Int32(theme.spacing(2)),
    }], ["children", (props_1 = {}, react.createElement(Undo, props_1))], ["onClick", (_arg) => {
        patternInput_1[1]((k) => (k + 1));
    }]])]]), sample], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]), ["elevation", 0]]), MuiHelpers_createElement(Grid, [["container", true], ["sx", {
        justifyContent: "flex-end",
        flexDirection: "row",
    }], (elements = [MuiHelpers_createElement(Tooltip, [["title", isExpanded ? "Hide code" : "Show code"], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
        patternInput[1](!isExpanded);
    }], ["color", "inherit"], ["children", (props_6 = {}, react.createElement(Code, props_6))]])]]), MuiHelpers_createElement(Tooltip, [["title", "View the source on GitHub"], ["children", MuiHelpers_createElement(IconButton, [["href", "https://github.com/ArtemyB/Feliz.MaterialUI/edit/master/docs-app/public/" + join("/", path)], ["component", "a"], ["color", "inherit"], ["children", (props_10 = {}, react.createElement(GitHub, props_10))]])]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Collapse, [["in", isExpanded], ["sx", {
        display: "block",
        ["\u0026.MuiCollapse-wrapperInner"]: {
            backgroundColor: bgColor,
        },
    }], (elements_1 = [(properties = ofArray([["source", markdownCodeBlock], ["escapeHtml", false], ["renderers", {
        code: (props_14) => createElement(Code_1, {
            language: props_14.language,
            code: props_14.value,
        }),
    }]]), Interop_reactApi_1.createElement(react_markdown, createObj(properties)))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    });
});

export function SampleViewer(sampleViewerInputProps) {
    const path = sampleViewerInputProps.path;
    const state_1 = useFeliz_React__React_useElmish_Static_78C5B8C8(init(path), update, [path])[0];
    if (state_1.tag === 1) {
        const xs = [MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["height", 400]])];
        return react.createElement(react.Fragment, {}, ...xs);
    }
    else if (state_1.tag === 2) {
        if (state_1.fields[0].tag === 1) {
            return MuiHelpers_createElement(Typography, [["sx", (delegateArg) => ((x) => ({
                color: x.palette.error.main,
            }))(delegateArg)], ["paragraph", true], ["children", state_1.fields[0].fields[0]]]);
        }
        else {
            return createElement(Demo, {
                getSample: state_1.fields[0].fields[0][0],
                markdownCodeBlock: state_1.fields[0].fields[0][1],
                path: state_1.fields[0].fields[0][2],
            });
        }
    }
    else {
        return null;
    }
}

